import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_plan_pricing = _resolveComponent("plan-pricing");
  const _component_router_view = _resolveComponent("router-view");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_plan_pricing), _createVNode(_component_router_view, null, {
    default: _withCtx(({
      Component,
      route
    }) => [(_openBlock(), _createBlock(_resolveDynamicComponent($options.layoutTypeToComponentMapper[route.meta.layout ?? 'Admin']), null, {
      default: _withCtx(() => [(_openBlock(), _createBlock(_KeepAlive, {
        include: ['project-tasks', 'project-list']
      }, [(_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
        key: route.path + $data.cacheVersion
      }))], 1024))]),
      _: 2
    }, 1024))]),
    _: 1
  })], 64);
}